var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteThinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.645917 0.645917C0.692363 0.599354 0.747538 0.562411 0.808283 0.537205C0.869028 0.511998 0.93415 0.499023 0.999917 0.499023C1.06568 0.499023 1.13081 0.511998 1.19155 0.537205C1.2523 0.562411 1.30747 0.599354 1.35392 0.645917L7.35392 6.64592C7.40048 6.69236 7.43742 6.74754 7.46263 6.80828C7.48784 6.86903 7.50081 6.93415 7.50081 6.99992C7.50081 7.06568 7.48784 7.13081 7.46263 7.19155C7.43742 7.2523 7.40048 7.30747 7.35392 7.35392L1.35392 13.3539C1.26003 13.4478 1.13269 13.5005 0.999917 13.5005C0.867141 13.5005 0.739804 13.4478 0.645917 13.3539C0.55203 13.26 0.499285 13.1327 0.499285 12.9999C0.499285 12.8671 0.55203 12.7398 0.645917 12.6459L6.29292 6.99992L0.645917 1.35392C0.599354 1.30747 0.562411 1.2523 0.537204 1.19155C0.511998 1.13081 0.499023 1.06568 0.499023 0.999917C0.499023 0.93415 0.511998 0.869029 0.537204 0.808284C0.562411 0.747539 0.599354 0.692363 0.645917 0.645917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteThinArrow);
export default __webpack_public_path__ + "static/media/whiteThinArrow.2d1c1abaf2bdc2b54f960fcb46db1595.svg";
export { ForwardRef as ReactComponent };